module.exports = __webpack_public_path__ + "img/guide1-7.cde2ba74.png";